import License from './License'
import NameDOBGender from './NameDOBGender'
import SSN from './SSN'
import TicketNumber from './TrafficTicketNumber'
import Email from './Email'
import FullName from './FullName'
import Name from './Name'
import DOB from './DOB'
import PhoneNumber from './PhoneNumber'
import LicenseIdAndDob from './LicenseIdAndDob'
import PlateNumber from './PlateNumber'
import LicenseState from './LicenseState'
import ZipCodeAndDob from './ZipCodeAndDob'
import PlateNumberAndLicenseState from './PlateNumberAndLicenseState'
import DOBPlateNumberAndLicenseState from './DOBPlateNumberAndLicenseState'
import LastNameDOBLicenseLicenseState from './LastNameDOBLicenseLicenseState'

import NYSlogo from '~/public/static/images/svg/NYSLogo.svg'
import NJLogo from '~/public/static/images/svg/NJLogo.png'
import LALogo from '~/public/static/images/png/logos/LALogo.png'
import SDLogo from '~/public/static/images/png/logos/SDLogo.png'
import SBLogo from '~/public/static/images/png/logos/SBLogo.png'
import SFLogo from '~/public/static/images/png/logos/SFLogo.png'
import OCLogo from '~/public/static/images/png/logos/OCLogo.png'
import KernLogo from '~/public/static/images/png/logos/KernLogo.png'
import SantaBarbaraLogo from '~/public/static/images/png/logos/SantaBarbaraLogo.png'
import VenturaLogo from '~/public/static/images/png/logos/VenturaLogo.png'
import GeorgiaLogo from '~/public/static/images/png/logos/GeorgiaLogo.png'
import MiamiLogo from '~/public/static/images/png/logos/MiamiLogo.png'
import AustinLogo from '~/public/static/images/png/logos/AustinLogo.png'
import NassauLogo from '~/public/static/images/png/logos/NassauLogo.png'
import HempsteadLogo from '~/public/static/images/png/logos/HempsteadLogo.png'
import SuffolkLogo from '~/public/static/images/png/logos/SuffolkLogo.svg'
import PennsylvaniaLogo from '~/public/static/images/png/logos/PennsylvaniaLogo.png'
import SeattleLogo from '~/public/static/images/png/logos/SeattleLogo.png'
import WashingtonLogo from '~/public/static/images/png/logos/WashingtonLogo.png'
import CaliforniaLogo from '~/public/static/images/png/logos/CaliforniaLogo.png'
import SantaClaraLogo from '~/public/static/images/png/logos/SantaClaraLogo.png'
import NCLogo from '~/public/static/images/png/logos/NCLogo.png'
import VirginiaLogo from '~/public/static/images/png/logos/VirginiaLogo.svg'
import WinItLogo from '~/public/static/images/svg/logo-shadow.svg'

export const SEARCH_OPTIONS = {
  NYSLicense: "NYSLicense",
  License: "License",
  nameDOBGender: "nameDOBGender",
  LicenseIdAndDob: "LicenseIdAndDob",
  lastFourSSN: "lastFourSSN",
  ticketNumber: "ticketNumber",
  licenseState: "licenseState",
  PlateNumber: "PlateNumber",
  Name: "Name",
  DOB: "DOB",
  ZipCodeAndDob: "ZipCodeAndDob",
  PlateNumberAndLicenseState: "PlateNumberAndLicenseState",
  DOBPlateNumberAndLicenseState: "DOBPlateNumberAndLicenseState",
  NassauLicenseId: "NassauLicenseId",
}

export const USER_INFO_SEARCH_OPTIONS = {
  fullName: "fullName",
  email: "email",
  phoneNumber: "phoneNumber",
}


export const SEARCH_OPTIONS_STATES = {
  'CAL_STATE' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.licenseState},
  'CAL' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.licenseState},
  'CAL_KERN' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'CAL_ORANGE' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'CAL_SAN_FRANCISCO' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.licenseState},
  'CAL_SAN_BERNARDINO' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.licenseState, columnThree: SEARCH_OPTIONS.Name},
  'CAL_SAN_DIEGO' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'CAL_VENTURA' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.licenseState},
  'CAL_SANTA_BARBARA' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'CAL_SANTA_CLARA' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.LicenseIdAndDob},
  'FL_MIAMI' : {columnOne: SEARCH_OPTIONS.NYSLicense, columnTwo: SEARCH_OPTIONS.licenseState},
  'GA' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.licenseState},
  'NY' : {columnOne: SEARCH_OPTIONS.NYSLicense, columnTwo: SEARCH_OPTIONS.lastFourSSN},
  'NY_CRIMINAL' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'NY_STATE' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.lastFourSSN, columnThree: SEARCH_OPTIONS.DOBPlateNumberAndLicenseState},
  'NY_HEMPSTEAD' : {columnOne: SEARCH_OPTIONS.PlateNumber, columnTwo: SEARCH_OPTIONS.licenseState},
  'NY_NASSAU' : {columnOne: SEARCH_OPTIONS.PlateNumber, columnTwo: SEARCH_OPTIONS.licenseState},
  'NY_SUFFOLK' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.licenseState},
  'NJ' : {columnOne: SEARCH_OPTIONS.NYSLicense, columnTwo: SEARCH_OPTIONS.licenseState},
  'PA_PHILADELPHIA' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'TX_AUSTIN' : {columnOne: SEARCH_OPTIONS.LicenseIdAndDob, columnTwo: SEARCH_OPTIONS.licenseState},
  'WA' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'WA_NEW_SEATTLE' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'NC' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.ZipCodeAndDob},
  'VA' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'NY_WESTCHESTER' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
  'CAL_SAN_JOAQUIN' : {columnOne: SEARCH_OPTIONS.Name, columnTwo: SEARCH_OPTIONS.DOB},
}

export const SEARCH_OPTIONS_STATES_LOGOS = {
  CAL: { logoUrl: LALogo, width: 300, height: undefined },
  CAL_STATE: { logoUrl: CaliforniaLogo, width: 325, height: undefined },
  CAL_KERN: { logoUrl: KernLogo, width: 300, height: undefined },
  CAL_ORANGE: { logoUrl: OCLogo, width: 300, height: undefined },
  CAL_SAN_FRANCISCO: { logoUrl: SFLogo, width: 300, height: undefined },
  CAL_SAN_BERNARDINO: { logoUrl: SBLogo, width: 300, height: undefined },
  CAL_SAN_DIEGO: { logoUrl: SDLogo, width: 300, height: undefined },
  CAL_VENTURA: { logoUrl: VenturaLogo, width: 300, height: undefined },
  CAL_SANTA_BARBARA: { logoUrl: SantaBarbaraLogo, width: 300, height: undefined },
  CAL_SANTA_CLARA: { logoUrl: SantaClaraLogo, width: 300, height: undefined },
  FL_MIAMI: { logoUrl: MiamiLogo, width: 300, height: undefined },
  GA: { logoUrl: GeorgiaLogo, width: 300, height: undefined },
  NJ: { logoUrl: NJLogo, width: 250, height: undefined },
  NY: { logoUrl: NYSlogo, width: 161, height: 35 },
  NY_STATE: { logoUrl: NYSlogo, width: 161, height: 35 },
  NY_CRIMINAL: { logoUrl: NYSlogo, width: 161, height: 35 },
  NY_HEMPSTEAD: { logoUrl: HempsteadLogo, width: 300, height: undefined },
  NY_NASSAU: { logoUrl: NassauLogo, width: 300, height: undefined },
  NY_SUFFOLK: { logoUrl: SuffolkLogo, width: 300, height: undefined },
  PA_PHILADELPHIA: { logoUrl: PennsylvaniaLogo, width: 300, height: undefined },
  TX_AUSTIN: { logoUrl: AustinLogo, width: 300, height: undefined },
  WA: { logoUrl: WashingtonLogo, width: 300, height: undefined },
  WA_NEW_SEATTLE: { logoUrl: SeattleLogo, width: 300, height: undefined },
  NC: { logoUrl: NCLogo, width:350, height: 50 },
  VA: { logoUrl: VirginiaLogo, width: 400, height: 55 },
  CAL_SAN_JOAQUIN: { logoUrl: LALogo, width: 300, height: undefined },
  DEFAULT: { logoUrl: WinItLogo, width: 130, height: 35 },
}

export const SEARCH_OPTIONS_STATES_IS_NYS_LICENSE = {
  CAL: false,
  CAL_STATE: false,
  CAL_KERN: false,
  CAL_ORANGE: false,
  CAL_SAN_FRANCISCO: false,
  CAL_SAN_BERNARDINO: false,
  CAL_SAN_DIEGO: false,
  CAL_VENTURA: false,
  CAL_SANTA_BARBARA: false,
  CAL_SANTA_CLARA: false,
  FL_MIAMI: false,
  GA: false,
  NJ: false,
  NY: true,
  NY_CRIMINAL: true,
  NY_STATE: true,
  NY_NASSAU: false,
  NY_SUFFOLK: false,
  NY_WESTCHESTER: false,
  PA_PHILADELPHIA: false,
  TX_AUSTIN: false,
  WA: false,
  WA_NEW_SEATTLE: false,
  NC: false,
  VA: false,
  CAL_SAN_JOAQUIN: false,
}


export const SEARCH_OPTIONS_VALIDATION_KEYS = {
  [SEARCH_OPTIONS.NYSLicense]: ['licenseID'],
  [SEARCH_OPTIONS.nameDOBGender]: ['firstName', 'middleName', 'lastName', 'DOBString', 'gender'],
  [SEARCH_OPTIONS.lastFourSSN]: ['SSN'],
  [SEARCH_OPTIONS.ticketNumber]: ['trafficTicketNumber'],
  [SEARCH_OPTIONS.LicenseIdAndDob]: ['licenseID', 'DOBString'],
  [SEARCH_OPTIONS.licenseState]: ['licenseState'],
  [SEARCH_OPTIONS.PlateNumber]: ['plateNumber'],
  [SEARCH_OPTIONS.Name]: ['firstName', 'middleName', 'lastName'],
  [SEARCH_OPTIONS.DOB]: ['DOBString'],
  [SEARCH_OPTIONS.ZipCodeAndDob]: ['zipCode', 'DOBString'],
  [SEARCH_OPTIONS.PlateNumberAndLicenseState]: ['plateNumber', 'licenseState'],
  [SEARCH_OPTIONS.DOBPlateNumberAndLicenseState]: ['DOBString', 'plateNumber', 'licenseState'],
  [SEARCH_OPTIONS.NassauLicenseId]: ['fullName', 'DOBString', 'licenseID', 'licenseState'],

}

export const SEARCH_OPTIONS_COMPONENTS = {
  [SEARCH_OPTIONS.NYSLicense]: License,
  [SEARCH_OPTIONS.nameDOBGender]: NameDOBGender,
  [SEARCH_OPTIONS.lastFourSSN]: SSN,
  [SEARCH_OPTIONS.ticketNumber]: TicketNumber,
  [SEARCH_OPTIONS.licenseState]: LicenseState,
  [SEARCH_OPTIONS.LicenseIdAndDob]: LicenseIdAndDob,
  [SEARCH_OPTIONS.PlateNumber]: PlateNumber,
  [SEARCH_OPTIONS.Name]: Name,
  [SEARCH_OPTIONS.DOB]: DOB,
  [SEARCH_OPTIONS.ZipCodeAndDob]: ZipCodeAndDob,
  [SEARCH_OPTIONS.PlateNumberAndLicenseState]: PlateNumberAndLicenseState,
  [SEARCH_OPTIONS.DOBPlateNumberAndLicenseState]: DOBPlateNumberAndLicenseState,
  [SEARCH_OPTIONS.NassauLicenseId]: LastNameDOBLicenseLicenseState,
}

export const USER_INFO_SEARCH_OPTIONS_COMPONENTS = {
  [USER_INFO_SEARCH_OPTIONS.fullName]: FullName,
  [USER_INFO_SEARCH_OPTIONS.email]: Email,
  [USER_INFO_SEARCH_OPTIONS.phoneNumber]: PhoneNumber,
}

export const NEW_YORK_STATE_LICENSE_COLUMNS = {
  one: [
    SEARCH_OPTIONS.nameDOBGender,
    SEARCH_OPTIONS.NYSLicense
  ],
  two: [
    SEARCH_OPTIONS.ticketNumber,
    SEARCH_OPTIONS.lastFourSSN
  ]
}

// Not being used.... for reference (maybe they will add more options in future?)
export const OTHER_STATE_LICENSE_COLUMNS = {
  one: [
    SEARCH_OPTIONS.nameDOBGender
  ],
  two: [
    SEARCH_OPTIONS.ticketNumber
  ]
}

